// src/components/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, firestore, signOutIdentityIfActive } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import AdminLogin from './AdminLogin';

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminChecked, setAdminChecked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) {
      return undefined;
    }
    if (!user) {
      setIsAdmin(false);
      setAdminChecked(true);
      return undefined;
    }

    setAdminChecked(false);
    setIsAdmin(false);
    let cancelled = false;

    (async () => {
      let tokenAdmin = false;
      try {
        const tr = await user.getIdTokenResult(true);
        tokenAdmin = tr.claims.admin === true;
      } catch {
        tokenAdmin = false;
      }
      if (cancelled) return;

      const adminDocRef = doc(firestore, 'admins', user.uid);
      try {
        const adminSnap = await getDoc(adminDocRef);
        if (cancelled) return;
        if (adminSnap.exists() || tokenAdmin) {
          setIsAdmin(true);
        } else {
          await auth.signOut();
          await signOutIdentityIfActive();
          alert('Access Denied. You are not authorized to access the admin panel.');
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
      } finally {
        if (!cancelled) setAdminChecked(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [user, loading, navigate]);

  if (loading || !adminChecked) {
    return <p>Loading...</p>;
  }

  return user && isAdmin ? children : <AdminLogin />;
};

export default ProtectedRoute;
